import React from "react"

import styles from "./anchorSection.module.scss"

const AnchorSection = props => <div id={props.anchorID} className={styles.visuallyHidden}></div>

export default AnchorSection
